<!-- 
程式：CarInsuranceUnRenewed.vue
功能：車險未續保名單主頁面
作者：i9400538 陳博承
完成：20120-04-29
-->
<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <button
        type="button"
        style="top:90px;right:20px;z-index:20"
        @click="backToIndex"
        class="position-absolute btn btn-default m-0"
      >回上一頁</button>
      <div
        class="mb-3"
        :class="{'section-loading': infoLoading}"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75 pr-3">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <i
              v-if="categoryInfo.upload_file =''"
              class="icon-attach text-orange ml-2"
            ></i>
            <span
              style="font-size: medium;color: black;"
            >{{ categoryInfo.upload_file | removeExten }}</span>
          </h4>
          <div class="mb-line" style>
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <car-insurance-un-renewed-data-table
          :height="data_table_height"
          @update="updateSelection"
          :table-data="tableData"
        />
      </div>
    </div>
    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import CarInsuranceUnRenewedDataTable from "../DataTable/CarInsuranceUnRenewedDataTable";
import SatisfactionModal from "../SatisfactionModal";
import {
  getCarInsuranceUnRenewed,
  getCategoryDetail,
  isSatisfactionSurveyFinish
} from "@/service";

export default {
  name: "CarInsuranceUnRenewed",
  mixins: [commonMixin],
  components: {
    CarInsuranceUnRenewedDataTable,
    SatisfactionModal
  },
  props: {
    status: String
  },
  computed: {},
  data() {
    //data block layout
    return {
      currentPage: 0,
      isLoading: false,
      isLoading_btn: false,
      isBtnEnble: true,
      infoLoading: false,
      tableData: [],
      selection: [],
      satisfactionModalOpen: false,
      data_table_height: 0,
      categoryInfo: {},
      currentRecord: {},
      info: {}
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = val;
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_INTEGRATED_MARKETING_LIST");
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status === "200") {
          this.isBtnEnble = result.body.isfinish === "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    init() {
      // 資料初始化
      this.checkIsSatisfactionSurveyFinish();
      // 取得列表資料
      this.isLoading = true;
      getCarInsuranceUnRenewed(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id
      ).then(result => {
        this.isLoading = false;
        if (result.header && result.header.status === "200") {
          this.tableData = result.body.result.map(item => {
            return {
              ceisdnm: item.ceisdnm || "",
              ceisdno: item.ceisdno || "",
              cartype: item.cartype || "",
              lic_no: item.lic_no || "",
              celpsdt: item.celpsdt || "",
              customer_sex: item.customer_sex || "",
              is_exist: item.is_exist || false //判斷是否有客戶資料
            };
          });
          this.registerHanlink(); // for hard word
        }
      });
      // 取得專區資訊
      this.getTitleInfo();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status === "200") {
          this.categoryInfo = result.body[0];
        }
      });
    }
  },
  mounted() {
    // 資料初始化
    this.init();
    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("orientationchange", function(event) {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>
